import { useSuspenseQuery } from "@tanstack/react-query";
import { Api } from "../api.config";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsDashboard = (from: string, to: string) => {
	const company = useCompany();
	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Reporting.Dashboard(
			company.id,
			from,
			to,
		),
		queryFn: () => Api.GetMetaAdsDashboard(from, to).then((r) => r.data),
		refetchInterval: 3600000,
	});
};
